var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-textarea',{ref:"mlTextarea",attrs:{"rows":_vm.rows,"counter":_vm.max,"readonly":_vm.readonly,"placeholder":_vm.$t(_vm.placeholder)},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }